<template>
  <div class="password-reset-page">
    <div class="password-reset-page__wrap container">
      <h1 class="title">Восстановление пароля</h1>
      <form @submit.prevent="submit" class="reset-form">
        <div class="form-row layout row wrap">
          <div class="flex xs12 sm4 d-flex align-center">
            <div class="form-label">Пароль:</div>
          </div>
          <div class="flex xs12 sm8 form-fields">
            <input
              type="password"
              class="form-input"
              :class="{ invalid: isInvalid('password') }"
              placeholder="Придумайте пароль"
              v-model="$v.form.password.$model"
            />
          </div>
        </div>

        <div class="form-row layout row wrap">
          <div class="flex xs12 sm4 d-flex align-center">
            <div class="form-label">Повторите пароль:</div>
          </div>
          <div class="flex xs12 sm8 form-fields">
            <input
              type="password"
              class="form-input"
              :class="{ invalid: isInvalid('repeatPassword') }"
              placeholder="Повторите пароль"
              v-model="$v.form.repeatPassword.$model"
            />
          </div>
        </div>

        <div class="form-row layout row wrap">
          <div class="flex xs12 offset-sm1 sm10">
            <p class="reset-form__message">{{ message }}</p>
          </div>
          <div class="flex xs12 offset-sm2 sm8">
            <AppBtn
              :loading="loading"
              @click="submit"
              round
              block
              color="orange-grad"
              class="px-6"
              type="submit"
            >
              <span>Отправить</span>
            </AppBtn>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { getValidationMessage } from "@utils/validation-messages";
import { requestAlert, showAlert } from "@/services/common/showAlert";
import { required, sameAs, minLength } from "vuelidate/lib/validators";
import service from "@/services/contest/auth";

const defaultForm = () => ({
  password: "",
  repeatPassword: ""
});

export default {
  name: "PasswordResetPage",

  data: () => ({
    form: defaultForm(),
    formErrors: {},
    loading: false,
    message: ""
  }),

  validations: {
    form: {
      password: { required, minLength: minLength(6) },
      repeatPassword: { required, sameAs: sameAs("password") }
    }
  },

  computed: {
    token() {
      return this.$route.query.token;
    }
  },

  methods: {
    clearError(field) {
      delete this.formErrors[field];
    },

    getError(field) {
      return (
        getValidationMessage(this.$v.form[field]) ||
        (this.formErrors[field] && this.formErrors[field][0])
      );
    },

    isInvalid(field) {
      return this.$v.form[field].$error || !!this.formErrors[field];
    },

    async submit() {
      if (this.loading) return;
      this.formErrors = {};
      this.message = "";
      this.$v.$touch();
      if (this.$v.$invalid) return;
      this.loading = true;

      try {
        const { success, data, message } = await service.resetPassword(
          this.token,
          this.form.password
        );
        if (success) {
          this.$router.replace({ name: "competition" });
          showAlert(message);
        } else {
          this.formErrors = data || {};
          this.message = message || "Не удалось выполнить запрос.";
        }
      } catch {
        requestAlert();
      }

      this.loading = false;
    }
  }
};
</script>

<style lang="scss">
.password-reset-page {
  padding: 80px 0;

  &__wrap {
    position: relative;
    z-index: 1;
    border-radius: 6px;
    background: gradient(#1e2135, #304d96, to bottom, 0.65, 0.65);
    padding: 30px;

    @include breakpoint("xs-only") {
      padding: 16px;
    }
  }
}

.reset-form {
  width: 470px;
  max-width: 100%;
  margin: 0 auto;
  padding-top: 30px;

  @include breakpoint("xs-only") {
    padding-top: 16px;

    .form-fields {
      padding-top: 0 !important;
    }
  }

  &__message {
    text-align: center;
    margin-bottom: 10px;
    min-height: 30px;
  }
}
</style>
